var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.84961,10c-13.772,0 -14.84961,1.07761 -14.84961,14.84961v0.30078c0,13.772 1.07761,14.84961 14.84961,14.84961h0.30078c13.772,0 14.84961,-1.07761 14.84961,-14.84961v-0.30078c0,-13.772 -1.07761,-14.84961 -14.84961,-14.84961zM23.75195,11h2.49609c11.826,0 12.75195,0.92595 12.75195,12.75195v2.49609c0,11.826 -0.92595,12.75195 -12.75195,12.75195h-2.49609c-11.826,0 -12.75195,-0.92595 -12.75195,-12.75195v-2.49609c0,-11.826 0.92595,-12.75195 12.75195,-12.75195zM33.49609,15c-0.828,0.002 -1.49809,0.67491 -1.49609,1.50391c0.002,0.828 0.67491,1.49809 1.50391,1.49609c0.828,-0.002 1.49809,-0.67491 1.49609,-1.50391c-0.002,-0.828 -0.67491,-1.49809 -1.50391,-1.49609zM24.98047,17c-4.418,0.011 -7.99147,3.60153 -7.98047,8.01953c0.01,4.418 3.60153,7.99147 8.01953,7.98047c4.418,-0.01 7.99147,-3.60153 7.98047,-8.01953c-0.01,-4.418 -3.60153,-7.99147 -8.01953,-7.98047zM24.98242,18c3.866,-0.009 7.00858,3.11642 7.01758,6.98242c0.009,3.866 -3.11642,7.00858 -6.98242,7.01758c-3.866,0.009 -7.00858,-3.11642 -7.01758,-6.98242c-0.009,-3.866 3.11642,-7.00858 6.98242,-7.01758z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/instaIcon.25f29b0c55f6195f9b54fa0ab4cbda6f.svg";
export { ForwardRef as ReactComponent };